import type { Lookups } from "../../types";
import type { FilterModule } from "../index";
import { VendorsFilter } from "./VendorsFilter";
import { getChips, getCount } from "./chips";
import { fromCompanyFilters, toCompanyFilters } from "./mapper";
import { defaultVendorsSlice, type VendorsSlice } from "./slice";

export type { VendorsSlice } from "./slice";
export { defaultVendorsSlice } from "./slice";

export const vendorsModule: FilterModule<VendorsSlice, Lookups> = {
  key: "vendors",
  defaultSlice: defaultVendorsSlice,
  Component: VendorsFilter,
  getChips,
  getCount,
  toCompanyFilters,
  fromCompanyFilters,
};
